import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 .326C5.557.326.333 5.433.333 11.731.333 18.03 5.557 23.137 12 23.137S23.667 18.03 23.667 11.73C23.667 5.433 18.443.326 12 .326m1.654 9.567c.114 0 .208.092.208.204v.692a.207.207 0 0 1-.208.204h-3.542c-.008.112-.008.232-.008.351v.917h3.547c.115 0 .208.092.208.204v.692a.207.207 0 0 1-.208.204h-3.398c.398 1.578 1.596 2.51 3.38 2.51.518 0 .966-.03 1.349-.104a.206.206 0 0 1 .247.198v1.09c0 .096-.07.178-.166.198a7 7 0 0 1-1.44.13c-2.86 0-4.766-1.497-5.214-4.022h-.784a.207.207 0 0 1-.208-.204v-.692c0-.112.093-.204.208-.204h.68v-.94c0-.111 0-.223.008-.325h-.688a.207.207 0 0 1-.208-.204V10.1c0-.112.093-.204.208-.204h.826c.513-2.398 2.395-3.816 5.171-3.816a7 7 0 0 1 1.44.137c.097.02.165.102.165.199v1.09h.002c0 .13-.12.223-.25.198a7 7 0 0 0-1.346-.112c-1.703 0-2.875.853-3.323 2.301z"
    }, null, -1)
  ]))]))
}
export default { render: render }